(function () {
    'use strict';

    angular
        .module('app')
        .controller('CatalogController', catalogController);

    function catalogController($scope, $cookies, $compile, $location, $rootScope, $filter, $timeout, $state, $stateParams, $window,
        BrandService, SeasonService, LinePlanService, BriefService, PatternService, PrototypeService, SharedData, cfpLoadingBar, ImageUrl, toaster) {
        var model = this;

        model.pageNumber = $state.params.pageNumber || 1;
        model.pageSize = $state.params.pageSize || 50;

        //custom url validation so the user can receive soft messages
        function validateUrl(v, id) {
            if (!v && id !== 'Season')
                return undefined;
            if (isNaN(parseInt(v))) {
                return 0;
            } else {
                return parseInt(v);
            }
        }
        
        model.brand = validateUrl($state.params.brandId, 'Brand');
        model.season = validateUrl($state.params.seasonId, 'Season');
        model.pattern = validateUrl($state.params.patternSeasonalId, 'Pattern');

        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] === 18) {
                if (userPermissionRow[1] === 1) {
                    model.SystemMessageRead = true;
                }
            }
        });

        if (!model.SystemMessageRead) {
            $state.go("permissionDenied");
        }
       
        var genderInclude = ["01", "02", "10", "24"];
        model.filterByGender = function (item) {
            return (genderInclude.indexOf(item.GenderKey)!==-1);
        }

        PatternService.getGenders("", 0).then(function (response) {
            if (response) {
                model.genders = response;
            }
        });

        //fill the Brands DDL
        BrandService.getBrandsByUser().then(function (response) {
            if (response) {
                model.brands = response;
                if (model.brand) 
                    model.getSeason(model.brand);
                if (!model.season) 
                    model.getCatalog();
            }
        });

        //fill the Seasons DDL after a user selects a brand
        model.getSeason = function (brand) {
            if (brand) {
                SeasonService.getSeasonsByBrand(brand, '').then(function (response) {
                    if (response) {
                        model.seasons = response;
                        if (model.season > -1)
                            model.getCatalog();
                    }
                });
            }
            else {
                model.seasons = [];
            }
        };        

        model.filterShow = true;
        model.toggleFilter = function () {
            model.filterShow = !model.filterShow;
        }

        model.loadCatalogPage = function (pageNumber, pageSize) {
            model.pageNumber = pageNumber;
            model.pageSize = pageSize;
            model.getCatalog();
        }

        model.getCatalog = function (a) {
            model.showPatternColorways = false; //set loader to true for the popup
            if (a) {
                model.pattern = undefined;
                model.pageNumber = 1;
            }

            //set season to 0 for the url
            if (model.season == null)
                model.season = 0;

            model.checkCount = 0;
            if (model.brand == null) {
                model.patterns = [];
                return;
            }
            model.loader(true);

            model.searchTerms = {
                BrandId: model.brand,
                SeasonId: model.season,
                GenderKey: model.GenderKey,
                PatternName: model.patternName,
                StatusId: 9999,
                pageNumber: model.pageNumber,
                pageSize: model.pageSize,
                sortColumn: "",
                sortDirection: "",
            }

            PatternService.searchPatterns(model.searchTerms, model.searchTerms.pageNumber, model.searchTerms.pageSize, model.searchTerms.sortColumn, model.searchTerms.sortDirection)
           .then(function (response) {
               angular.forEach(response.results, function (k, v) {
                   k.ImagePath = k.ImagePath.replace("size=70", "size=200");
               });
               model.patterns = response.results;

               model.pagerData = {
                   CurrentPageNumber: response.currentPage,
                   PageSize: response.pageSize,
                   TotalPageCount: response.totalPages,
                   TotalRecords: response.totalRecords,
                   firstRecord: response.firstRecord,
                   lastRecord: response.lastRecord
               };

               if (model.patterns.length === 0) {
                   if (model.pattern) {
                       toaster.pop({
                           type: 'note',
                           title: 'Pattern Invalid',
                           body: 'The pattern you are looking for was not found.',
                           timeout: 5000
                       });
                       model.pattern = undefined;
                   }
               }

               var pIndex = model.patterns.map(function (e) { return e.PatternSeasonalId }).indexOf(model.pattern);
               if (pIndex>-1) {
                   model.assignPatternData(model.patterns[pIndex]);
               }

               model.stateChange();
               model.loader(false);
           });
        }

        model.getCatalogBlur = function () {
            if (model.patternName !== model.searchTerms.PatternName) {
                model.getCatalog();
            }
        }

        model.patternCheck = function () {
            var count = $filter('filter')(model.patterns, { checked: true });
            model.checkCount = count.length;
        }

        model.getMultiplePatternColorways = function () {
            var checked = $filter('filter')(model.patterns, { checked: true });
            model.assignPatternData(checked);
        }

        model.assignPatternData = function (item,clear) {
            model.loader(true);

            var psid = item.PatternSeasonalId;

            //Get Pattern Prototypes
            //probably make this a call, instead of multiple calls in a loop
            PatternService.getPatternPrototypes(psid, true).then(function (data) {
                angular.forEach(data, function (k, v) {
                    k.ImagePath = ImageUrl + '?projectId=' + k.PrototypeId + '&projectLevel=4&imageType=1&size=350';
                    k.ImagePathFull = ImageUrl + '?projectId=' + k.PrototypeId + '&projectLevel=4&imageType=1&size=650';
                });

                model.patternColorways = [];

                model.patternColorways.push({
                    Pattern: item,
                    Colorways: $filter('filter')(data, { StatusName: '!Canceled' })
                });

                model.loader(false);
                model.showPatternColorways = true;
                model.stateChange();
            });

            model.pattern = item.PatternSeasonalId
            model.lastViewed = item.PatternSeasonalId;
        }

        model.lastViewed = function (psid) {
            if (!model.patternColorways)
                return;
            if (model.patternColorways.map(function (e) { return e.Pattern.PatternSeasonalId }).indexOf(psid) > -1) {
                return true;
            }
        }

        model.loaderTimer = '';
        model.loader = function (v) {
            if (v) {
                model.loading = v;
            } else {
                $timeout.cancel(model.loaderTimer);
                model.loaderTimer = $timeout(function () {
                    model.loading = v;
                }, 200)
            }
        }

        model.hidePatternColorways = function (a) {
            model.showPatternColorways = false;
            model.pattern = undefined;
            model.stateChange();
        }

        //get default brand and season
        function getDefaultBrandAndSeason() {
            SharedData.getUserDefaults().then(function (response) {
                if (response) {
                    model.brand = response.brandId;
                    model.season = response.seasonId;
                    model.getCatalog();
                }
            });            
        }

        function cfl(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }

        model.stateChange = function() {
            var stateArray = ["brand", "season","pattern"];
            var stateString = "catalog";
            for (var i = 0; i < 3; i++) {
                if (model[stateArray[i]]>-1) {
                    stateString += cfl(stateArray[i]) /*+ '.'*/;
                }
            }

            var string1 = '(' + $state.params.brandId + '-' + $state.params.seasonId + '-' + $state.params.patternSeasonalId + ')';
            var string2 = '(' + model.brand + '-' + model.season + '-' + model.pattern + ')';
            //stateString = stateString.substr(0, stateString.length - 1);
            if (string1 !== string2) {
                $state.go(stateString, { pageNumber: model.pageNumber, pageSize: model.pageSize, brandId: model.brand, seasonId: model.season, patternSeasonalId: model.pattern }, { notify: false });
            }

            setBreadcrumbs();
        }

        //lol what is this
        function setBreadcrumbs() {
            var div = '<i class="fa fa-angle-right" aria-hidden="true"></i> ';
            var brandArray = model.brand && model.brands ? model.brands[model.brands.map(function (e) { return e.BrandId }).indexOf(model.brand)] : "";
            var seasonArray = model.season && model.seasons ? model.seasons[model.seasons.map(function (e) { return e.SeasonId }).indexOf(model.season)] : "";
            var patternArray = model.pattern && model.patterns ? model.patterns[model.patterns.map(function (e) { return e.PatternSeasonalId }).indexOf(model.pattern)] : "";
            var brand = brandArray ? '<a href="/catalog/'+model.pageNumber+'/'+model.pageSize+'/'+model.brand+'">' + brandArray.BrandName + '</a>' : "";
            var season = seasonArray ? div + '<a href="/catalog/' + model.pageNumber + '/' + model.pageSize + '/' + model.brand + '/'+model.season+'">' + seasonArray.Description + '</a>' : "";
            var pattern = patternArray ? div + '<a href="/catalog/' + model.pageNumber + '/' + model.pageSize + '/' + model.brand + '/' + model.season + '/' + model.pattern + '">' + patternArray.PatternName + '</a>' : "";
            $scope.breadCrumb = brand + season + pattern;
        }

        if (!model.brand)
            getDefaultBrandAndSeason();

        //slider stuff
        model.getColumnSize = function (v) {
            switch(v) {
                case 1:
                    return 'col-md-2';
                case 2:
                    return 'col-20';
                case 3:
                    return 'col-md-3';
                case 4:
                    return 'col-md-4';
                case 5:
                    return 'col-md-6';
                case 6:
                    return 'col-md-12';
            }
        }

        //assign default column size
        var defaultColumnSize = 4;
        model.columnClass = model.getColumnSize(defaultColumnSize);
        model.columnClass2 = model.getColumnSize(3);

        $('#slider').slider({
            value: defaultColumnSize,
            min: 3,
            max: 6,
            step: 1,
            slide: function (event, ui) {
                model.columnClass = model.getColumnSize(ui.value);
                model.sliderValue = 7 - ui.value;
                $scope.$apply();
            }
        });
        $('#slider2').slider({
            value: 4,
            min: 1,
            max: 3,
            step: 1,
            slide: function (event, ui) {
                model.columnClass2 = model.getColumnSize(ui.value);
                model.sliderValue2 = 7 - ui.value;
                $scope.$apply();
            }
        });

        var slider = angular.element(document.querySelectorAll('#slider .ui-slider-handle'));
        model.sliderValue = 7 - defaultColumnSize;
        var element = angular.element('<div class="ui-slider-value">{{vm.sliderValue}}</div>')
        slider.append(element);
        $compile(element)($scope);

        var slider2 = angular.element(document.querySelectorAll('#slider2 .ui-slider-handle'));
        model.sliderValue2 = 7 - 3;
        var element2 = angular.element('<div class="ui-slider-value">{{vm.sliderValue2}}</div>')
        slider2.append(element2);
        $compile(element2)($scope);

        $scope.windowGridHeight = function () {
            if (window.outerHeight >= 768) {
                return window.innerHeight - 252;
            } else {
                var size = $scope.totalRecords < $scope.pageSize ? $scope.totalRecords : $scope.pageSize;
                return ($scope.pageSize * 142);
            }
        };
    }
})();
